import styled from '@emotion/styled';
import ReportProblemRoundedIcon from '@mui/icons-material/ReportProblemRounded';
import { FormHelperText } from "@mui/material";

const CustomHelperText = styled(FormHelperText)`
  margin-top: .6rem;
  display: flex;
  align-items: flex-start;
  gap: .6rem;
`

const ErrorMessage = ({error = false, message}) => {
  return (
      <CustomHelperText error={error}>
        <ReportProblemRoundedIcon fontSize="small" />
        <span>{message}</span>
      </CustomHelperText>
  )
}

export default ErrorMessage;